"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject;
const _excluded = ["children", "as", "align", "gap", "flex", "styles", "onClick", "itemProp", "itemScope", "itemType", "className", "forwardedRef"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const defaultProps = {
  children: '',
  gap: 0,
  styles: '',
  className: '',
  as: ''
};
function Row(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      children,
      as,
      align,
      gap,
      flex,
      styles,
      onClick,
      itemProp,
      itemScope,
      itemType,
      className,
      forwardedRef
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    align: align,
    as: as,
    gap: gap,
    flex: flex,
    styles: styles,
    itemProp: itemProp,
    itemScope: itemScope,
    itemType: itemType,
    className: className,
    onClick: onClick,
    ref: forwardedRef
  }, restOfProps), children);
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"])), _ref => {
  let {
    gap
  } = _ref;
  return gap ? "gap: ".concat(gap, "px;") : '';
}, _ref2 => {
  let {
    flex
  } = _ref2;
  return flex ? "flex: ".concat(flex, ";") : '';
}, _ref3 => {
  let {
    align
  } = _ref3;
  let styles = '';
  if (align === 'left') styles += 'justify-content: flex-start;';
  if (align === 'center') styles += 'justify-content: center;';
  if (align === 'right') styles += 'justify-content: flex-end;';
  if (align === 'space-between') styles += 'justify-content: space-between;';
  if (_styled.default.length === 0) styles += 'flex: 1;';
  return styles;
}, _ref4 => {
  let {
    styles
  } = _ref4;
  return styles;
});
var _default = exports.default = Row;